import type { Variants } from "motion/react";

const STILL = { duration: 0 };

/**
 * The variants of the menu Standard and Gennemsigtig open without `layout.header.navigation`: a circle grows from the
 * menu button and the links rise one by one. `still` opens and closes it at once.
 */
export function legacyMenuVariants(
  still: boolean,
): Record<"circle" | "list" | "item", Variants> {
  return {
    circle: {
      visible: {
        "--re-menu-circle": "300%",
        transition: still
          ? STILL
          : { type: "spring", stiffness: 20, restDelta: 2 },
      },
      hidden: {
        "--re-menu-circle": "0%",
        transition: still
          ? STILL
          : { delay: 0.2, type: "spring", stiffness: 400, damping: 40 },
      },
    },
    list: {
      visible: {
        transition: still
          ? STILL
          : { staggerChildren: 0.02, delayChildren: 0.3 },
      },
      hidden: {
        transition: still
          ? STILL
          : { staggerChildren: 0.02, staggerDirection: -1 },
      },
    },
    item: {
      visible: { y: 0, opacity: 1, ...(still ? { transition: STILL } : {}) },
      hidden: {
        y: 50,
        opacity: 0,
        transition: still ? STILL : { duration: 0.05 },
      },
    },
  };
}
